export const SHOW_HEDER_OPTIONS = 'SHOW_HEDER_OPTIONS';
export const NAV_SELECTION_CHANGE = 'NAV_SELECTION_CHANGE';
